export enum OccupancyType {
  NotAssigned = 0,
  PrimaryResidence = 1,
  SecondaryResidence = 2,
  InvestmentProperty = 3,
}
